import { useClassNames } from "@/utils/classNames";

import styles from "./TileProgressBar.module.scss";
import { TileProgressBarProps } from "./types";

/**
 * TileProgressBar component is used to display a progress bar with different styles and sizes on tiles.
 *
 * @param size - The size of the progress bar
 * @param barStyle - The style of the progress bar
 * @param progress - The current progress percentage (0-100)
 * @param className - Additional class names to apply to the component
 * @param attr - Additional HTML attributes to apply to the component
 *
 * @returns The TileProgressBar component
 *
 * @example
 * ```tsx
 * <TileProgressBar
 *   size={TileProgressBarSize.Medium}
 *   barStyle={TileProgressBarStyle.Floating}
 *   progress={50}
 * />
 * ```
 */
const TileProgressBar = ({
  size,
  barStyle,
  progress,
  className,
  ...attr
}: TileProgressBarProps) => {
  const cn = useClassNames(
    styles,
    styles["tile-progress-bar"],
    styles[`size-${size}`],
    styles[barStyle],
    className,
  );

  return (
    <div className={cn} {...attr}>
      <div className={styles["progress"]} style={{ width: `${progress}%` }} />
    </div>
  );
};

export { TileProgressBar };
